function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlueCheck({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 20207",
    transform: "translate(-873 -242)"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 4337",
    width: 34,
    height: 34,
    rx: 17,
    transform: "translate(873 242)",
    style: {
      fill: "#1b74e4"
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "check (2)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 16313",
    d: "m16.261 58.05-8.837 8.837a1.677 1.677 0 0 1-2.371 0L.491 62.324a1.677 1.677 0 0 1 2.371-2.371l3.376 3.377 7.652-7.652a1.677 1.677 0 0 1 2.371 2.371z",
    transform: "translate(881.625 197.719)",
    style: {
      fill: "#fff"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueCheck);
export default __webpack_public_path__ + "static/media/blue-check.6f817e7e9cbc083e0f72b9d371c980ff.svg";
export { ForwardRef as ReactComponent };